import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const renderIcon = IconComp => {
  if (!IconComp) {
    return null
  }

  const iconProps = {
    fontSize: 40,
    htmlColor: '#FFFFFF',
    style: { color: '#FFFFFF' },
  }

  if (typeof IconComp === 'function') {
    try {
      const rendered = IconComp()
      if (React.isValidElement(rendered)) {
        return React.cloneElement(rendered, {
          ...iconProps,
          style: { ...iconProps.style, ...rendered.props.style },
        })
      }
    } catch (error) {
      // IconComp is a component reference, not a render prop.
    }

    const Icon = IconComp
    return <Icon {...iconProps} />
  }

  const Icon = IconComp
  return <Icon {...iconProps} />
}

const SectionEmptyState = ({
  Icon,
  title,
  caption,
  action,
  bordered = true,
}) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.root} ${bordered ? classes.bordered : ''}`}>
      {Icon ? (
        <Box className={classes.iconCircle}>{renderIcon(Icon)}</Box>
      ) : null}
      <Typography variant="h6" component="h2" className={classes.title}>
        {title}
      </Typography>
      {caption ? (
        <Typography variant="body2" className={classes.caption}>
          {caption}
        </Typography>
      ) : null}
      {action ? <Box className={classes.actions}>{action}</Box> : null}
    </Box>
  )
}

SectionEmptyState.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
  title: PropTypes.node.isRequired,
  caption: PropTypes.node,
  action: PropTypes.node,
  bordered: PropTypes.bool,
}

export default SectionEmptyState
